import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Box, Button, Text, useToast } from '@chakra-ui/react';

function ReloadPrompt() {
    const toast = useToast();
    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r) {
            console.log('SW Registered: ' + r);
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    React.useEffect(() => {
        if (needRefresh) {
            console.log("New content available, reloading...");
            // Force update automatically for now to resolve the "stuck" state for users
            updateServiceWorker(true);
        }
    }, [needRefresh, updateServiceWorker]);


    return null;
}

export default ReloadPrompt;
